export const initialState = {
    category: [],
    meals: [],
    alternative_categories: [],
    arrival: new Date(),
    departure: new Date(),
    adult: "",
    child: "",
    childAge: "",
    location: [],
    accommodationType: [],

};

export default function clientReducer(state = initialState, action) {

    switch (action.type) {

        case "category":
            return {
                ...state,
                category: action.payload
            };

        case "meals":
            return {
                ...state,
                meals: action.payload
            };

        case "alternative_categories":
            return {
                ...state,
                alternative_categories: action.payload
            };

        case "arrival":
            return {
                ...state,
                arrival: action.payload
            };

        case "departure":
            return {
                ...state,
                departure: action.payload
            };

        case "adult":
            return {
                ...state,
                adult: action.payload
            };

        case "child":
            return {
                ...state,
                child: action.payload
            };

        case "childAge":
            return {
                ...state,
                childAge: action.payload
            };

        case "accommodationType":
            return {
                ...state,
                accommodationType: action.payload
            };
            
        default:
            return state;
    }
}